import React, { useRef } from "react"
import Button from "@src/components/core-button"
import Spinner from "@src/components/core-spinner"
import { UserContext } from "@src/context/user-context"
import FormInput from "../../reusable/forms/form-input"
import { useForm, FormProvider } from "react-hook-form"
import { validateEmail } from "@src/utils/validators"
import { FormActions } from "../../reusable/forms/auth-forms.styled"

function FormVerify({
  status,
  setStatus,
  switchToLogin,
  emailContext,
  children,
}) {
  const methods = useForm({
    defaultValues: {
      email: emailContext,
    },
  })
  const formRef = useRef()
  const { watch } = methods
  const email = watch("email")

  const handleProgrammaticSubmit = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(
        new Event("submit", { cancelable: true, bubbles: true }),
      )
    }
  }

  const validateSixDigits = value => {
    const sixDigitsPattern = /^\d{6}$/
    return sixDigitsPattern.test(value) || "Must contain exactly 6 digits"
  }

  return (
    <FormProvider {...methods}>
      <p className="h2 verify">Verify your email</p>
      {status.success ? (
        <p className="center">Your account has been verified!</p>
      ) : email ? (
        <p className="center">
          {`We've sent a 6-digit code to `}
          <span className="bold">{email}</span>
        </p>
      ) : (
        <p className="center">{`Please check your email for a 6-digit code.`}</p>
      )}
      <UserContext.Consumer>
        {({ verify }) => {
          const handleSubmit = ({ email, code }) => {
            setStatus({ ...status, pending: true })
            verify(email, code)
              .then(() => {
                setStatus({
                  success: true,
                  pending: false,
                  formMessage: null,
                })
              })
              .catch(error => {
                setStatus({
                  success: false,
                  pending: false,
                  formMessage: error,
                })
              })
          }
          return (
            <>
              {status.success ? null : (
                <form
                  ref={formRef}
                  onSubmit={methods.handleSubmit(handleSubmit)}
                >
                  <FormInput
                    label="Email"
                    name="email"
                    type="email"
                    validate={validateEmail()}
                  />
                  <FormInput
                    label="Verification Code"
                    placeholder="Enter 6-digit password reset code"
                    name="code"
                    type="text"
                    validate={validateSixDigits}
                  />
                </form>
              )}
              <FormActions>
                {status.formMessage && (
                  <p className="form-error">{status.formMessage}</p>
                )}
                {status.pending ? (
                  <Button variant="rounded" disabled>
                    Verifying <Spinner color="white" size="sm" />
                  </Button>
                ) : (
                  <>
                    {status.success ? null : (
                      <Button
                        variant="rounded"
                        type="submit"
                        onClick={handleProgrammaticSubmit}
                      >
                        Verify Account
                      </Button>
                    )}
                    <Button
                      variant="rounded"
                      color="outline"
                      onClick={switchToLogin}
                    >
                      Back to login
                    </Button>
                  </>
                )}
                {children}
              </FormActions>
            </>
          )
        }}
      </UserContext.Consumer>
    </FormProvider>
  )
}

export default FormVerify
